import { JumpMode } from "./JumpMode";
export class JumpCalculatorCoefficients {
    constructor(jumpmode) {
        this.similarProjectPenalty = 1;
        this.similarSensorgroupPenalty = 3;
        this.similarOrientation = 4;
        this.similarDistance = 6;
        this.timeDiff = jumpmode === JumpMode.similar ? 0 : jumpmode === JumpMode.latest ? 1 : 0;
        this.similarDirection = 5;
        this.similarAxisDirectionPenalty = 0.6;
    }
}
//# sourceMappingURL=JumpCalculatorCoefficients.js.map